export const GET_ALL_FAQS = 'GET_ALL_FAQS';
export const GET_EDIT_DATA = 'GET_EDIT_DATA';
export const GET_FAQ_DATA = 'GET_FAQ_DATA';
export const GET_NEWSLETTER_CONTENT = 'GET_NEWSLETTER_CONTENT';
export const GET_PRIVACY_POLICY_DATA = 'GET_PRIVACY_POLICY_DATA';
export const GET_TERM_DATA = 'GET_TERM_DATA';
export const GET_COKIE_POLICY_DATA = 'GET_COKIE_POLICY_DATA';
export const GET_HOW_IT_WORK_DATA = 'GET_HOW_IT_WORK_DATA';
export const GET_ABOUT_DATA = 'GET_ABOUT_DATA';
export const GET_DPA_DATA = 'GET_DPA_DATA';
export const GET_RETURN_POLICY_DATA = 'GET_RETURN_POLICY_DATA';
export const GET_SELLERTERM_DATA = 'GET_SELLERTERM_DATA';
export const GET_BUYERTERM_DATA = 'GET_BUYERTERM_DATA';
export const GET_PROHIBITEDITEMS_DATA = 'GET_PROHIBITEDITEMS_DATA';
export const GET_TRUSTSAFETY_DATA = 'GET_TRUSTSAFETY_DATA';
export const GET_PRIVACY_POLICY_DATA_NL = 'GET_PRIVACY_POLICY_DATA_NL';
export const GET_TERM_DATA_NL = 'GET_TERM_DATA_NL';
export const GET_COKIE_POLICY_DATA_NL = 'GET_COKIE_POLICY_DATA_NL';
export const GET_HOW_IT_WORK_DATA_NL = 'GET_HOW_IT_WORK_DATA_NL';
export const GET_ABOUT_DATA_NL = 'GET_ABOUT_DATA_NL';
export const GET_DPA_DATA_NL = 'GET_DPA_DATA_NL';
export const GET_RETURN_POLICY_DATA_NL = 'GET_RETURN_POLICY_DATA_NL';
export const GET_FAQ_DATA_NL = 'GET_FAQ_DATA_NL';
export const GET_ALL_FAQS_NL = 'GET_ALL_FAQS_NL';
export const GET_NEWSLETTER_CONTENTNL = 'GET_NEWSLETTER_CONTENTNL';
export const GET_HOME_CONTENTNL = 'GET_HOME_CONTENTNL';
export const GET_SELLERTERM_DATA_NL = 'GET_SELLERTERM_DATA_NL';
export const GET_BUYERTERM_DATA_NL = 'GET_BUYERTERM_DATA_NL';
export const GET_PROHIBITEDITEMS_DATA_NL = 'GET_PROHIBITEDITEMS_DATA_NL';
export const GET_TRUSTSAFETY_DATA_NL = 'GET_TRUSTSAFETY_DATA_NL';
export const GET_HOMEPAGE_HERO_SLIDES = 'GET_HOMEPAGE_HERO_SLIDES';
export const GET_HOMEPAGE_HERO_SLIDES_NL = 'GET_HOMEPAGE_HERO_SLIDES_NL';
export const GET_CMS_DOCUMENTS = "GET_CMS_DOCUMENTS";
export const GET_CMS_DOCUMENT = "GET_CMS_DOCUMENT";
export const GET_CMS_DOCUMENT_VERSIONS = "GET_CMS_DOCUMENT_VERSIONS";
export const GET_ARTICLES = "GET_ARTICLES";

